import { render } from "./IconQrcode.vue?vue&type=template&id=35b363c0"
import script from "./IconQrcode.vue?vue&type=script&lang=js"
export * from "./IconQrcode.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__